import React, { createContext, useContext, useState } from "react";

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  const loginUser = (userData) => {
    setUser(userData);
  };

  const logoutUser = () => {
    setUser(null);
  };

  /* useEffect(() => {
    // Retrieve user info from localStorage on initial load
    const storedUserInfo = getUserInfo();
    if (storedUserInfo) {
      setUser(storedUserInfo);
    }
  }, []); */


  return (
    <UserContext.Provider value={{ user, loginUser, logoutUser }}>
      {children}
    </UserContext.Provider>
  );
};

export const useUser = () => {
  return useContext(UserContext);
};